import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import { authApi } from "../services/api/auth/authApi"

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoading: false,
      error: null,
      hasHydrated: false,

      setHasHydrated: (state) => set({ hasHydrated: state }),

      clearError: () => set({ error: null }),

      resetAuth: () =>
        set({
          user: null,
          token: null,
          isLoading: false,
          error: null,
        }),

      login: async (credentials) => {
        set({ isLoading: true, error: null })
        try {
          const { data } = await authApi.login(credentials)
          const { user, token } = data.data

          set({
            user,
            token,
            isLoading: false,
          })

          return data
        } catch (err) {
          const msg = err?.response?.data?.message || "Login failed"
          set({ error: msg, isLoading: false })
          throw err
        }
      },

      register: async (payload) => {
        set({ isLoading: true, error: null })
        try {
          const { data } = await authApi.register(payload)
          const { user, token } = data.data

          set({
            user,
            token,
            isLoading: false,
          })

          return data
        } catch (err) {
          const msg = err?.response?.data?.message || "Registration failed"
          set({ error: msg, isLoading: false })
          throw err
        }
      },

      logout: async () => {
        try {
          await authApi.logout()
        } catch (_) {
        } finally {
          get().resetAuth()
        }
      },

      logoutAll: async () => {
        try {
          await authApi.logoutAll()
        } catch (_) {
        } finally {
          get().resetAuth()
        }
      },

      refreshToken: async () => {
        try {
          const { data } = await authApi.refresh()
          const { token } = data.data
          set({ token })
          return token
        } catch (err) {
          get().resetAuth()
          throw err
        }
      },

      fetchMe: async () => {
        try {
          const { data } = await authApi.me()
          set({ user: data.data })
          return data.data
        } catch (err) {
          throw err
        }
      },

      changePassword: async (payload) => {
        set({ isLoading: true, error: null })
        try {
          const { data } = await authApi.changePassword(payload)
          set({ isLoading: false })
          return data
        } catch (err) {
          const msg = err?.response?.data?.message || "Password change failed"
          set({ error: msg, isLoading: false })
          throw err
        }
      },

      updateProfile: (data) =>
        set((state) => ({
          user: { ...state.user, ...data },
        })),

      isAuthenticated: () => !!get().token,
      role: () => get().user?.role || null,

      isAdmin: () => get().user?.role === "admin",
      isBarangayOfficial: () => get().user?.role === "barangay_official",
      isNationalOfficial: () => get().user?.role === "national_official",
      isResident: () => get().user?.role === "resident",

      hasRole: (role) => get().user?.role === role,
      hasAnyRole: (roles) => roles.includes(get().user?.role),
    }),
    {
      name: "barangay360-auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        token: state.token,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    }
  )
)